import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';
import { IScreenPacket, IFrameData, ScreenMessageFlags, MessageType } from 'app/modules/remote-control-ng/definitions';

/** PC_FULLSCREEN and PC_DELTASCREEN MessageTypes for the standard RC */
export class ScreenMessage extends BaseMessage {
    public screenPacket: IScreenPacket;
    public messageBytes: number;
    
    public deserializeBody(buffer: MemoryBuffer): void {
        this.messageBytes = buffer.getByteArray().length;

        const rotation = buffer.readUInt8();
        const scale = buffer.readUInt8();
        const imageDataFlags = buffer.readUInt32BE();
        
        this.screenPacket = <IScreenPacket>{
            scale,
            rotation,
            imageDataFlags,
            // eslint-disable-next-line no-bitwise
            ackRequired: (imageDataFlags & ScreenMessageFlags.AckRequired) !== 0,
            fullscreen: this.header.command === MessageType.PC_FULLSCREEN,
        };
        this.deserializeMediaData(buffer);
    }
    
    public deserializeMediaData(buffer: MemoryBuffer): void {
        const numImages = buffer.readUInt32BE();
        const frameData: IFrameData[] = [];

        for (let images = 0; images < numImages; images++) {
            const x = buffer.readUInt16BE();
            const y = buffer.readUInt16BE();
            const imageData = buffer.readBlob();
            frameData[images] = <IFrameData>{
                x,
                y,
                binImageData: imageData
            };
        }

        // eslint-disable-next-line no-bitwise
        this.screenPacket.isJpegCodec = (this.screenPacket.imageDataFlags & ScreenMessageFlags.JpegCodec) !== 0;
        this.screenPacket.frameData = frameData;
        this.screenPacket.numImage =frameData.length;
    }
}

/** PC_FULLSCREEN and PC_DELTASCREEN MessageTypes for the streaming RC
 * Streaming screen message deserializes data in a different format. The protocol defines which interpretation
 * will be applied to PC_FULLSCREEN and PC_DELTASCREEN amd only one of these message classes will be registered
 * in the message factory
 */
export class StreamingMessage extends ScreenMessage {
    constructor() { super() }

    public override deserializeMediaData(buffer: MemoryBuffer): void {
        const pos = buffer.getPosition();
        const data = buffer.getByteArray();
        this.screenPacket.mp4 = data.subarray(pos, data.byteLength);
    }
}
